import {
  FETCH_AGENCY_LIST_REQUEST,
  FETCH_AGENCY_LIST_SUCCESS,
  FETCH_AGENCY_LIST_FAILURE,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  FETCH_ACCOUNT_DETAILS_REQUEST,
  FETCH_ACCOUNT_DETAILS_SUCCESS,
  FETCH_ACCOUNT_DETAILS_FAILURE,
  DOWNLOAD_AGENCY_TEMPLATE_REQUEST,
  DOWNLOAD_AGENCY_TEMPLATE_SUCCESS,
  DOWNLOAD_AGENCY_TEMPLATE_FAILURE,
  UPLOAD_AGENCY_FUNDS_REQUEST,
  UPLOAD_AGENCY_FUNDS_SUCCESS,
  UPLOAD_AGENCY_FUNDS_FAILURE,
  SET_ACTIVE_TAB,
  SET_ORDERS_FILTERS,
  CLEAR_ERROR,
  CLEAR_TEMPLATE_DOWNLOAD_SUCCESS,
  CLEAR_AGENCY_FUNDS_UPLOAD_SUCCESS,
} from './actions';

const initialState = {
  // Agency List
  agencyList: [],
  agencyListLoading: false,
  agencyListError: null,
  
  // Orders
  orders: [],
  ordersLoading: false,
  ordersError: null,
  ordersPagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    pageSize: 20
  },
  
  // Account Details
  accountDetails: [],
  accountLoading: false,
  accountError: null,
  
  
  // Download Template
  templateDownloadLoading: false,
  templateDownloadError: null,
  templateDownloadSuccess: false,
  
  // Upload Agency Funds
  agencyFundsUploadLoading: false,
  agencyFundsUploadError: null,
  agencyFundsUploadSuccess: false,
  agencyFundsUploadResult: null,
  
  // UI State
  activeTab: 'orders', // 'orders' or 'agency-wallet'
  ordersFilters: {
    recipientEmail: '',
    searchValue: '',
    orderDate: 'last-24-hours',
    agency: 'all'
  },
  
  // General
  loading: false,
  error: null
};

const superAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    // Agency List
    case FETCH_AGENCY_LIST_REQUEST:
      return {
        ...state,
        agencyListLoading: true,
        agencyListError: null
      };
      
    case FETCH_AGENCY_LIST_SUCCESS:
      return {
        ...state,
        agencyList: action.payload.data,
        agencyListLoading: false,
        agencyListError: null
      };
      
    case FETCH_AGENCY_LIST_FAILURE:
      return {
        ...state,
        agencyList: [],
        agencyListLoading: false,
        agencyListError: action.payload.error
      };
    
    // Orders
    case FETCH_ORDERS_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
      
    case FETCH_ORDERS_SUCCESS:
      const ordersData = action.payload.data.orders;
      const safeOrders = Array.isArray(ordersData) ? ordersData : [];
      
      return {
        ...state,
        orders: safeOrders,
        ordersPagination: {
          currentPage: action.payload.data.current_page || 1,
          totalPages: action.payload.data.total_pages || 1,
          totalItems: action.payload.data.total_records || 0,
          pageSize: action.payload.data.page_size || 20
        },
        ordersLoading: false,
        ordersError: null
      };
      
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        orders: [],
        ordersLoading: false,
        ordersError: action.payload.error
      };
    
    // Account Details
    case FETCH_ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        accountLoading: true,
        accountError: null
      };
      
    case FETCH_ACCOUNT_DETAILS_SUCCESS:
      const accountsData = action.payload.data.accounts;
      const safeAccounts = Array.isArray(accountsData) ? accountsData : [];
      
      return {
        ...state,
        accountDetails: safeAccounts,
        accountLoading: false,
        accountError: null
      };
      
    case FETCH_ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        accountDetails: [],
        accountLoading: false,
        accountError: action.payload.error
      };
    
    // Download Template
    case DOWNLOAD_AGENCY_TEMPLATE_REQUEST:
      return {
        ...state,
        templateDownloadLoading: true,
        templateDownloadError: null,
        templateDownloadSuccess: false
      };
      
    case DOWNLOAD_AGENCY_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateDownloadLoading: false,
        templateDownloadError: null,
        templateDownloadSuccess: true
      };
      
    case DOWNLOAD_AGENCY_TEMPLATE_FAILURE:
      return {
        ...state,
        templateDownloadLoading: false,
        templateDownloadError: action.payload.error,
        templateDownloadSuccess: false
      };
    
    // Upload Agency Funds
    case UPLOAD_AGENCY_FUNDS_REQUEST:
      return {
        ...state,
        agencyFundsUploadLoading: true,
        agencyFundsUploadError: null,
        agencyFundsUploadSuccess: false,
        agencyFundsUploadResult: null
      };
      
    case UPLOAD_AGENCY_FUNDS_SUCCESS:
      return {
        ...state,
        agencyFundsUploadLoading: false,
        agencyFundsUploadError: null,
        agencyFundsUploadSuccess: true,
        agencyFundsUploadResult: action.payload.data
      };
      
    case UPLOAD_AGENCY_FUNDS_FAILURE:
      return {
        ...state,
        agencyFundsUploadLoading: false,
        agencyFundsUploadError: action.payload.error,
        agencyFundsUploadSuccess: false,
        agencyFundsUploadResult: null
      };
    
    // UI Actions
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload
      };
      
    case SET_ORDERS_FILTERS:
      return {
        ...state,
        ordersFilters: {
          ...state.ordersFilters,
          ...action.payload
        }
      };
      
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        templateDownloadError: null,
        agencyFundsUploadError: null
      };
      
    case CLEAR_TEMPLATE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        templateDownloadSuccess: false
      };
      
    case CLEAR_AGENCY_FUNDS_UPLOAD_SUCCESS:
      return {
        ...state,
        agencyFundsUploadSuccess: false,
        agencyFundsUploadResult: null
      };
    
    default:
      return state;
  }
};

export default superAdminReducer;
